export const PAGE_SIZE_OPTIONS = [20, 50, 100, 200];
export const DEFAULT_PAGINATION = {
    page: 1,
	pageSize: 100,
};